import { render, staticRenderFns } from "./SubjectNotes.vue?vue&type=template&id=7dc805b1&scoped=true"
import script from "./SubjectNotes.ts?vue&type=script&lang=ts&external"
export * from "./SubjectNotes.ts?vue&type=script&lang=ts&external"
import style0 from "./subject-notes.scss?vue&type=style&index=0&id=7dc805b1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc805b1",
  null
  
)

export default component.exports